// App-wide constants
export const LOGO_URL = "/logo.png";
export const BRAND_NAME = "Blue Mountain Group";
